import * as React from 'react';
import { connect } from 'react-redux';
import { checkClaimPartyModalShow, scrollToScrollClass, updateClaimPartyReducer, validateClaimParties, handleNextStep, handleStepBack, setFnolReducer, setStep } from '../../../actions/claimSubmitActions';
import { ThirdPartyConfigurations, THIRDPARTY_TYPE_PEDESTRIAN } from '../../../constants/constants';
import { IThirdPartyConfig } from '../../../interfaces/ThirdParty/ThirdPartyInterface';
import KPInputTextArea from '../../BaseTemplate/SSPCustomComponentLibrary/KPInputTextArea/KPInputTextArea';
import ClaimsThirdPartyComponent from '../ThirdParty/ClaimsThirdPartyComponent';

class Pedestrians extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.state = {
            submitted: false,
            errorList: [],
            reRender: true,
            unknownReasonError: false,
        }
        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleHasPedestrian = this.handleHasPedestrian.bind(this);
        this.handleThirdPartyUnknownReason = this.handleThirdPartyUnknownReason.bind(this);
    }

    async handleNext() {
        let errorList = [];
        if (this.props.claimSubmit.hasPedestrian) {
            errorList = await this.props.dispatchAction(validateClaimParties(ThirdPartyConfigurations.find(x => x.thirdPartyConfigType === THIRDPARTY_TYPE_PEDESTRIAN) as IThirdPartyConfig));
        }
        if (errorList.length != 0) {
            await this.setState({
                errorList: errorList,
                submitted: true,
                reRender: false
            })
            await this.setState({
                reRender: true
            });
            scrollToScrollClass()
        }
        if (this.props.claimSubmit.hasPedestrian === undefined || (this.props.claimSubmit.hasPedestrian === false && (!this.props.claimSubmit.thirdPartyUnknownReason || this.props.claimSubmit.thirdPartyUnknownReason === ''))) {
            await this.setState({ unknownReasonError: true});
        }
        else if ((this.props.claimSubmit.hasPedestrian === false && this.props.claimSubmit.thirdPartyUnknownReason && this.props.claimSubmit.thirdPartyUnknownReason !== '') || (this.props.claimSubmit.hasPedestrian === true && errorList.length === 0)) {
            this.props.dispatchAction(handleNextStep())
        }
    }

    handleBack() {
        this.props.dispatchAction(handleStepBack())
    }

    async handleHasPedestrian(flag: boolean) {
        if (flag && this.props.claimSubmit.hasPedestrian != flag) {
            await this.props.dispatchAction(updateClaimPartyReducer(THIRDPARTY_TYPE_PEDESTRIAN, 'add'));
            this.props.dispatchAction(setFnolReducer('hasPedestrian', flag))
        }
        else if (!flag) {
            await this.props.dispatchAction(checkClaimPartyModalShow(ThirdPartyConfigurations.find(x => x.thirdPartyConfigType === THIRDPARTY_TYPE_PEDESTRIAN) as IThirdPartyConfig, 'hasPedestrian'));
        }
    }

    handleThirdPartyUnknownReason(e: any) {
        this.setState({ unknownReasonError: false });
        this.props.dispatchAction(setFnolReducer('thirdPartyUnknownReason', e.target.value))
    }

    public render() {
        return <>
            <div className="col ssp-container-fnol-claim-info ssp-container-fnol-step-header-padding road-surface">
                <div className="">
                    <div className="col-12 nopa ssp-header-fnol-claim-info">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src={'/my-policy/Images/Claims/Numbers/' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red.png'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                <h3>{this.props.claimSubmit.selectedClaimStep.title}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma glassclaims-parent-row ">
                    <div className="col-12 nopa">
                        <hr className="hr-minus21px" />
                    </div>
                    <div className="col nopa">
                        <p className="text-16 glassclaims-intro-p stationary-p"><b>Do you have the details of the pedestrian involved<br className="fnol-newline" /></b></p>
                    </div>
                    <div className="nopa text-lg-right glassclaims-button-col">
                        <div className="row noma glassclaims-button-row">
                            <div className="col nopa glassclaims-button-no">
                                <button className={this.props.claimSubmit.hasPedestrian != undefined && this.props.claimSubmit.hasPedestrian === false ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} id="otherPartiesNo" onClick={() => this.handleHasPedestrian(false)}>No</button>
                            </div>
                            <div className="glassclaims-mobile-gutter nopa"></div>
                            <div className="col nopa glassclaims-button-yes">
                                <button className={this.props.claimSubmit.hasPedestrian != undefined && this.props.claimSubmit.hasPedestrian === true ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} id="otherPartiesYes" onClick={() => this.handleHasPedestrian(true)}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.claimSubmit.hasPedestrian === true && this.state.reRender &&
                    <ClaimsThirdPartyComponent ThirdParties={this.props.claimSubmit.pedestrians} ErrorList={this.state.errorList} Submitted={this.state.submitted} />
                }
                {this.props.claimSubmit.hasPedestrian === false &&
                    <div className="col-12 nopa mt-30px mb-20px">
                        <p className={'ssp-form-label ssp-opacity-1 follow-up-placeholder'}>
                            If no, please tell us why you don't have the details:
                        </p>
                        <KPInputTextArea id="thirdpartyunknownreason" type="textarea" name="thirdPartyUnknownReason"
                            className={"follow-up-bold-placeholder follow-up-hide-placeholder" + (this.state.unknownReasonError ? " error-textarea-follow-up" : "")}
                            label={"Tap here to start typing..."}
                            placeholder={"Tap here to start typing..."}
                            value={this.props.claimSubmit.thirdPartyUnknownReason}
                            notice=""
                            noticeType=""
                            noticeMessage="Required"
                            alwaysShowLabel={false}
                            labelAfterSelection={""}
                            required={true}
                            handleChange={(e) => this.handleThirdPartyUnknownReason(e)}
                        />
                        {this.state.unknownReasonError && <div className="form-inline-error">Required</div>}
                    </div>
                }
                <div className="row noma road-surface-footer">
                    <div className="col-12 nopa">
                        <hr className="hr-minus21px" />
                    </div>
                </div>
                <div className="col-12 nopa fnol-where-it-happened-buttonholder pb-20px">
                    <button id="next-btn" className="btn btn-solid-red fnol-buttonreverse-button-next" onClick={this.handleNext}>Next</button>
                    <button id="back" className="btn btn-outline-red fnol-buttonreverse-button-back" onClick={this.handleBack}>Back</button>
                </div>
            </div>
        </>
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Pedestrians)